import { createContext, useContext, type ReactNode } from 'react';

const FileServerContext = createContext<string | null>(null);

export function FileServerProvider({
  url,
  children,
}: {
  url: string;
  children: ReactNode;
}) {
  return (
    <FileServerContext.Provider value={url}>
      {children}
    </FileServerContext.Provider>
  );
}

export function useFileServerUrl(): string {
  const url = useContext(FileServerContext);
  if (url === null) {
    throw new Error(
      'useFileServerUrl must be used within a <FileServerProvider>',
    );
  }
  return url;
}
